import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
`

export const FieldLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FieldContent = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 32px;

  > :first-child {
    flex: 1;
    max-width: 100%;
  }
`

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  height: 36px;
`

export const ButtonContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;

  width: 36px;
  height: 36px;

  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-base, #fff);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`
